import { defineStore } from "pinia"
import storage from "~/services/storage"
import { EBOOK_CATEGORIES } from "~/constants/productCategories"
import { isEbookSection } from "~/helpers"
import http from "~/services/http"
import { FilterValuesType, ProductFilterStateType, SlugTitleType } from "~/types/schema"

const userProductFilterStore = defineStore("productFilterStoreStore", {
  state: () => ({
    products: [] as ProductFilterStateType[],
    filters: {
      categories: [] as SlugTitleType[],
      grades: [] as SlugTitleType[],
      subjects: [] as SlugTitleType[],
      curriculumTypes: [] as SlugTitleType[],
    },
    filterValues: {} as FilterValuesType,
    valuesloading: false as boolean,
    loading: false as boolean,
  }),

  actions: {
    getFetchParams(): Record<string, any> {
      const formattedParams: Record<string, any> = {}

      formattedParams["categories[]"] = this.filters.categories.map((category) => category.slug)

      if (this.filters.grades.length > 0) {
        formattedParams["grades[]"] = this.filters.grades.map((grade) => grade.slug)
      }

      if (this.filters.subjects.length > 0) {
        formattedParams["subjects[]"] = this.filters.subjects.map((subject) => subject.slug)
      }

      if (this.filters.curriculumTypes.length > 0) {
        formattedParams["curriculum_types[]"] = this.filters.curriculumTypes.map((type) => type.slug)
      }

      return formattedParams
    },

    fetchProducts({ successCallback, errorCallback }: IErrorAndSuccessCallbacks) {
      const params: Record<string, any> = this.getFetchParams()

      this.loading = true
      http.get({
        url: "v1/products/filter",
        params,
        successCallback: (context) => {
          this.products = context.response._data.products
          this.loading = false
          successCallback && successCallback(context)
        },
        errorCallback: (context) => {
          this.loading = false
          errorCallback && errorCallback(context)
        },
      })
    },

    fetchFilterValues({ successCallback, errorCallback }: IErrorAndSuccessCallbacks) {
      const params = this.getFetchParams()
      this.valuesloading = true
      http.get({
        url: "v2/filters",
        params,
        successCallback: (context) => {
          this.valuesloading = false
          this.filterValues = context.response._data.filters
          successCallback && successCallback(context)
        },
        errorCallback: (context) => {
          this.valuesloading = false
          errorCallback && errorCallback(context)
        },
      })
    },

    removeFilter(slug: string) {
      const filterArrays = Object.values(this.filters)

      for (let i = 0; i < filterArrays.length; i++) {
        const searchArray = filterArrays[i]
        for (let u = 0; u < searchArray.length; u++) {
          if (searchArray[u].slug === slug) {
            searchArray.splice(u, 1)
            return
          }
        }
      }
    },

    resetFilters(newCategories?: SlugTitleType[] | null) {
      const route = useRoute()

      if (newCategories) {
        this.filters = storage.getProductFilters(route.name as string)
        this.filters.categories = newCategories
      }

      if (isEbookSection(route)) {
        this.filters.categories = [...EBOOK_CATEGORIES]
      }

      if (!newCategories) {
        this.filters.subjects = []
        this.filters.grades = []
        this.filters.curriculumTypes = []
      }
    },
  },
})

export { userProductFilterStore }
